require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/fn/regexp/escape.js
// module id = 1135
// module chunks = 168707334958949